var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getRouter),expression:"!getRouter"}]}),_c('breadcrumb',{staticClass:"breadcrumb-container"}),_c('app-main'),_c('StFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }